import { DeviceInterface } from './AccountSecurityProvider'

/**
 *
 */
export const stubDevices: DeviceInterface[] = [
    {
        id: 1,
        name: 'Windows',
        currentDevice: true,
        location: 'New York, NY, USA',
        date: 'Yesterday',
        type: 'Desktop'
    },
    {
        id: 2,
        name: 'iOS 12',
        location: 'San Francisco, CA, USA',
        date: '26 Apr, 2025',
        type: 'Mobile'
    },
    {
        id: 3,
        name: 'MacBook Pro M1',
        location: 'California, USA',
        date: '20 Apr, 2025',
        type: 'Desktop'
    },
    {
        id: 4,
        name: 'iOS 13',
        location: 'San Diego, CA, USA',
        date: '22 Apr, 2025',
        type: 'Mobile'
    },
    {
        id: 5,
        name: 'MacBook Pro M2',
        location: 'Boston, MA, USA',
        date: '23 Apr, 2025',
        type: 'Desktop'
    },
    {
        id: 6,
        name: 'iOS 14',
        location: 'New York, USA',
        date: '24 Apr, 2025',
        type: 'Mobile'
    }
]
